import { render, staticRenderFns } from "./FriendrequestMessageElement.vue?vue&type=template&id=1a160446&scoped=true&"
import script from "./FriendrequestMessageElement.vue?vue&type=script&lang=babel&"
export * from "./FriendrequestMessageElement.vue?vue&type=script&lang=babel&"
import style0 from "./FriendrequestMessageElement.vue?vue&type=style&index=0&id=1a160446&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a160446",
  null
  
)

export default component.exports